import { createContext, useContext } from 'react';

const BottomSheetContext = createContext(false);

export const BottomSheetProvider = BottomSheetContext.Provider;

/** True inside the mobile bottom sheet, false in the desktop dialog. */
export function useInBottomSheet() {
  return useContext(BottomSheetContext);
}
